import { render } from "./fullPage.vue?vue&type=template&id=130e4c5f&scoped=true&lang=pug"
import script from "./fullPage.vue?vue&type=script&setup=true&lang=js"
export * from "./fullPage.vue?vue&type=script&setup=true&lang=js"

import "./fullPage.vue?vue&type=style&index=0&id=130e4c5f&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130e4c5f"]])

export default __exports__